<template>
  <div 
    ref="panel" class="panel"
    :style="isFixed ? fixedStyle : null"
  >
   <slot></slot>
  </div>

</template>

<script>
export default {
  name: "FixedPanel",
  data() {
    return {
      parentRef: null,
      isFixed: false,
      isChangingState: false,
      fixedStyle: {
        position: 'fixed',
        bottom: '0',
        left: '0',
        width: '100%',
        zIndex: 9999,
      },
    }
  },
  methods: {
    setParentRef(parentRef) {
      this.parentRef = parentRef
      this.setPosition()
      this.handleScroll()

      this.resizeObserver = new ResizeObserver(() => {
        if (this.isChangingState) {
          this.isChangingState = false
          return 
        }
        this.setPosition();
        this.handleScroll();
      });

      this.resizeObserver.observe(this.parentRef);
    },
    getScreenBreakpoint() {
      const width = window.innerWidth;
      if (width >= 1260) {
        return 'lg';
      } else if (width >= 1024) {
        return 'md';
      } else {
        return 'sm';
      }
    },
    getParentBottom() {
      const panelRef = this.$refs.panel;

      if (!this.parentRef || !panelRef ||  panelRef.offsetHeight <= 0) {
        return 0
      }
      const parentRefRect = this.parentRef.getBoundingClientRect();


      return this.isFixed 
        ? parentRefRect.bottom + window.scrollY
        : parentRefRect.bottom + window.scrollY - panelRef.offsetHeight;
    },
    setPosition() {
      if (!this.parentRef) {
        return
      }

      // Bottom of orderItems container relative to document minus panel element height
      const parentRefRect = this.parentRef.getBoundingClientRect();
      this.fixedStyle.left = parentRefRect.left + 'px';
      this.fixedStyle.width = (parentRefRect.width) + 'px';
      this.handleScroll();
      
    },
    handleScroll() {

      const scrollBottom = window.scrollY + window.innerHeight - 50; // 50px buffer for better UX
      const parentRefBottom = this.getParentBottom()

      if (!parentRefBottom ) {
        return
      }

      // If scroll bottom is less than orderItems's bottom and screen is large, keep fixed
      const newFixedValue = scrollBottom < parentRefBottom && this.getScreenBreakpoint() === 'lg';
      if (this.isFixed !== newFixedValue) {
        this.isChangingState = true
        this.isFixed = newFixedValue;
      }
      // this.isFixed = true
    },
  },
  mounted() {
    this.$emit('panel-mounted', this.setParentRef);

    this.setPosition();
    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('resize', this.setPosition);
  },
   beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
    window.removeEventListener('resize', this.setPosition);

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  },
}
</script>

<style scoped>
.panel {
  background: #41464c !important;
  color: white;
  visibility: visible;
  margin: 1rem 0;
  padding: 1rem;
  border-radius: 1rem;
}
</style>